import React from 'react';
import { useLang } from '../../contexts/LanguageContext';

// Kompakt DE/TR dil seçici. Seçim localStorage'da tutulur (switchLang) ve
// tüm uygulamada korunur.
export default function LangSwitch({ className = '' }) {
  const { lang, switchLang } = useLang();
  return (
    <div className={`inline-flex items-center rounded-lg border border-gray-200 overflow-hidden text-xs font-medium ${className}`}>
      <button
        type="button"
        onClick={() => switchLang('de')}
        className={`px-2.5 py-1 transition-colors ${lang === 'de' ? 'bg-gs-red text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => switchLang('tr')}
        className={`px-2.5 py-1 transition-colors ${lang === 'tr' ? 'bg-gs-red text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
      >
        TR
      </button>
    </div>
  );
}
